import { Dropdown, Menu, MenuProps } from 'antd';
import React from 'react';
import { AiOutlineLogout } from 'react-icons/ai';
import { CgProfile } from 'react-icons/cg';
import { FaChartLine, FaListUl, FaUserCircle } from 'react-icons/fa';
import { FiSettings } from 'react-icons/fi';
import { MdOutlineMailOutline } from 'react-icons/md';
import { VscReferences } from 'react-icons/vsc';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useIsTeamMember from '../../../hooks/useIsTeamMember';
import { HEADERMENU_PATH } from '../../../routes/RoutesURL';
import { RootState } from '../../../store/rootReducer';
import LoginActions from '../../login/redux/actions';

type ItemKeys = 'account_setting' | 'logout' | 'deals' | 'investment' | 'referrals' | 'contact_us';

interface Items {
    key: ItemKeys;
    label: React.ReactNode;
    icon: React.ReactNode;
}

type Props = {
    setContactUs: (f: boolean) => void;
    isActive: (a: string[]) => boolean;
    isVertical: boolean;
};

const HeaderMenu: React.FC<Props> = ({ setContactUs, isActive, isVertical }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isTeamMember: boolean = useIsTeamMember();

    const user = useSelector((state: RootState) => state.user.user);

    const logout = () => {
        dispatch(LoginActions.removeUserData());
        return navigate(HEADERMENU_PATH.login);
    };

    const headerMenuClick: MenuProps['onClick'] = (e) => {
        const key = e.key as ItemKeys;
        if (key === 'account_setting') {
            navigate(HEADERMENU_PATH.settings);
        }
        if (key === 'logout') {
            logout();
        }
        if (key === 'contact_us') {
            setContactUs(true);
        }
        if (key === 'deals') {
            navigate(HEADERMENU_PATH.deals);
        }
        if (key === 'referrals') {
            navigate(HEADERMENU_PATH.referral);
        }
        if (key === 'investment') {
            navigate(HEADERMENU_PATH.investments);
        }
    };

    let items: Items[] = [
        {
            key: 'deals',
            label: <p className={isActive(['/deals']) ? 'active_link_m !text-[#0f2240]' : ''}>Deals</p>,
            icon: (
                <FaListUl
                    className={`text-lg mr-3 text-gray-700 ${
                        isActive(['/deals']) ? 'active_link_m !text-[#0f2240]' : ''
                    }`}
                    size="1.2rem"
                />
            ),
        },
        {
            key: 'investment',
            label: (
                <p className={isActive(['/portfolio', '/repayment']) ? 'active_link_m !text-[#0f2240]' : ''}>
                    Investments
                </p>
            ),
            icon: (
                <FaChartLine
                    className={`text-lg mr-3 text-gray-700 ${
                        isActive(['/portfolio', '/repayment']) ? 'active_link_m !text-[#0f2240]' : ''
                    }`}
                    size="1.2rem"
                />
            ),
        },
        {
            key: 'referrals',
            label: <p className={isActive(['/referral']) ? 'active_link_m !text-[#0f2240]' : ''}>Referral</p>,
            icon: (
                <VscReferences
                    className={`text-lg mr-3 text-gray-700 ${
                        isActive(['/referral']) ? 'active_link_m !text-[#0f2240]' : 'font-[WorkSans-Semibold]'
                    }`}
                    size="1.2rem"
                />
            ),
        },
        {
            key: 'account_setting',
            label: (
                <p className={isActive(['/settings']) ? 'active_link_m !text-[#0f2240]' : 'font-[WorkSans-Semibold]'}>
                    Account Settings
                </p>
            ),
            icon: (
                <FiSettings
                    className={`text-lg mr-3 text-gray-700 ${
                        isActive(['/settings']) ? 'active_link_m !text-[#0f2240]' : 'font-[WorkSans-Semibold]'
                    }`}
                    size="1.2rem"
                />
            ),
        },
        {
            key: 'contact_us',
            label: 'Contact Us',
            icon: <MdOutlineMailOutline className="text-lg mr-3 text-gray-700" size="1.2rem" />,
        },
        {
            key: 'logout',
            label: 'Logout',
            icon: <AiOutlineLogout className="text-lg mr-3 text-gray-700" size="1.2rem" />,
        },
    ];

    if (!isVertical) {
        items.splice(0, 3);
    }
    if (isTeamMember && isVertical) {
        items.splice(2, 1);
    }

    const menu = (
        <div className="bg-white py-2 px-4 shadow-2xl rounded-md">
            <div className="border-b-2 pb-3">
                <div className="flex flex-col justify-center items-center">
                    <CgProfile className="p-2" size="2.9rem" color="#c49a6d" />
                    <label className="text-base  font-[WorkSans-Semibold]">{user && user.email}</label>
                </div>
            </div>
            <Menu className="border-0 header_menu" items={items} onClick={headerMenuClick} />
        </div>
    );

    return (
        <div>
            {!isVertical ? (
                <Dropdown placement="bottomRight" overlay={menu} trigger={['click']} overlayClassName="common_dropdown">
                    <FaUserCircle
                        color="#142C53"
                        size="1.4rem"
                        className="cursor-pointer ml-3"
                        onClick={(e) => e.preventDefault()}
                    />
                </Dropdown>
            ) : (
                <Dropdown placement="bottomRight" overlay={menu} trigger={['click']} overlayClassName="common_dropdown">
                    <div className="menu_div cursor-pointer">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </Dropdown>
            )}
        </div>
    );
};

export default HeaderMenu;
